export type ReviewsPerProduct = ProductWithReviews[];
export interface ProductWithReviews {
  internalProductName: string;
  reviews: Review[];
}
export interface Country {
  name: string;
  icon: string;
}
export interface Review {
  type?: ReviewerType;
  name: string;
  text: string;
  imageUrl?: string;
  date: Date;
  country: {
    name: string;
    icon: string;
  };
  stars: number;
  influencer?: Influencer;
}

export interface Influencer {
  ig_handle: string;
  ig_followers_count: string;
  photo: string;
  videoId?: string;
}

export enum ReviewerType {
  INFLUENCER,
  CUSTOMER,
}
// import { ReviewsTypes, ReviewerType } from "../types/reviews";
const reviewsPerProduct: ReviewsPerProduct = [
  {
    internalProductName: "ipanema",
    reviews: [
      {
        type: ReviewerType.INFLUENCER,
        name: "Yasmine",
        text: "Words fail to express my gratitude to SHEMSI , I can't describe what I'm feeling really. This is the first time to sleep well throughout my periods. I want to say I was too hesitated and afraid to try shemsi without pads and when I bought them I said to myself if not real I would use them with pads. But I am excited , no leaks, no stain , no odor , only comfort and freedom like you are wearing not",
        imageUrl: "/images/reviews/harikaol_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@harikaol",
          ig_followers_count: "159k",
          photo: "/images/reviews/harikaol_profile.webp",
          videoId: "k1OW7T5vIi8",
        },
      },

      {
        name: "Dalia",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداًً و كان سهل اوي اني اطلبه",
        stars: 5,
        date: new Date(2022, 11, 2),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Salma",
        type: ReviewerType.CUSTOMER,
        text: "المنج ممتاز بس مكنتش عارفه اغسله ازاي, لكن خدمة العملاء ساعدوني",
        stars: 5,
        date: new Date(2022, 10, 4),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.CUSTOMER,
        name: "Sandra",
        text: "I got it for my daughter and she said they're really good with her",
        date: new Date(2022, 10, 12),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nada",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداً  بس ياريت لو كان في الوان",
        stars: 5,
        date: new Date(2022, 10, 8),
        country: {
          name: "Qalioubiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Marwa",
        text: "agréablement surpis de la douceur du coton",
        imageUrl: "/images/reviews/marwarioui_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@marwarioui",
          ig_followers_count: "2.1M",
          photo: "/images/reviews/marwarioui_profile.webp",
          videoId: "hg_s1eYSYrU",
        },
      },
      {
        name: "Dalia",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 10, 7),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "شيما",
        type: ReviewerType.CUSTOMER,
        text: "طلبته كذا مرة و كويس جداً",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Mansoura",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Aya",
        type: ReviewerType.CUSTOMER,
        text: "المنج ممتاز بس مكنتش عارفه اغسله ازاي, لكن خدمة العملاء ساعدوني",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Hadeer",
        text: "I love shemsi, I was so happy to try it and it really feels super hygienic. You really have to try it, to understand it!",
        date: new Date(2022, 11, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,
        imageUrl: "/images/reviews/thehadeerhameed_review.webp",
        influencer: {
          ig_handle: "@thehadeerhameed",
          ig_followers_count: "263k",
          photo: "/images/reviews/thehadeerhameed_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },

      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "طلبته مرتين و كل مرة كان مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nermine",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "esraa",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Sohag",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Zineb",
        text: "its crazy that this underwear works so well, it's a game changer ",
        imageUrl: "/images/reviews/zineb_aghrib_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@zineb_aghrib",
          ig_followers_count: "368k",
          photo: "/images/reviews/zineb_aghrib_profile.webp",
          videoId: "HmIuRWoxvaw",
        },
      },
      {
        name: "Amira",
        type: ReviewerType.CUSTOMER,
        text: "طلبته لبنتي و عجبها جداً",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "aya",
        type: ReviewerType.CUSTOMER,
        text: "المنتج روعة",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Sarah",
        text: "I really think it's amazing that this is Made in Egypt, it's amazing product for woman and it makes me feel so feminine ",
        imageUrl: "/images/reviews/glammedbysarah_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@glammedbysarah_",
          ig_followers_count: "223k",
          photo: "/images/reviews/glammedbysarah_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداً",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Amr",
        type: ReviewerType.CUSTOMER,
        text: "مراتي شكرت فيه",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Fayyoum",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "رحاب",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداً و بقترحه جداً للناس",
        date: new Date(2022, 9, 26),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Zeezee",
        text: "This is so much better then normal period products. Its good for the environment and has 0 chemical inside and is made of organic fabrics from Egypt. It's better for the planet and for you!",
        imageUrl: "/images/reviews/zeezeesaifelnasr_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@zeezeesaifelnasr",
          ig_followers_count: "111k",
          photo: "/images/reviews/zeezeesaifelnasr_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Salma",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة منه جداً",
        stars: 5,
        date: new Date(2022, 9, 25),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Sahar",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Mansora",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "نورا",
        type: ReviewerType.CUSTOMER,
        text: "طلبت 3 قطع و 2 منهم كانو حلوين جداً, و التالت حاسة انه مختلف لكن متأكدة ان لو طلع في حاجة مش مضبوطة خدمة العملاء هيساعدوني",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Port Said",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Jumana",
        text: "Period Underwear is super nice because you can sleep in peace with it. No more stress during your Period. I recommend it!! ",
        imageUrl: "/images/reviews/jumana_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@jumanaabdallah",
          ig_followers_count: "70.5k",
          photo: "/images/reviews/jumana_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Perry",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 21),
        country: {
          name: "Qalioubiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "shahed",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة جداً من المنتج و من خدمة العملاء",
        stars: 5,
        date: new Date(2022, 9, 20),
        country: {
          name: "Suez",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Malak",
        text: "Period Underwear is comfy its super nice to wear and it works! I've worn it for 10 Hours without any leaks 🤗",
        imageUrl: "/images/reviews/malakiees_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@malakiies",
          ig_followers_count: "163k",
          photo: "/images/reviews/malakiees_profile.webp",
          videoId: "eHdk-thVPds",
        },
      },
      {
        name: "Abdullah",
        type: ReviewerType.CUSTOMER,
        text: "المنتج كويس",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Enas",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Ismailia",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Youmna",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداًً و بستخدمه و انا في الGym",
        date: new Date(2022, 9, 19),
        stars: 5,
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 15),
        country: {
          name: "Kafr El Sheikh",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Salma",
        text: "I love shemsi as it allows me to feel free at the gym, no stress, no leak and ultra comfy for sports",
        imageUrl: "/images/reviews/merakisbubble_review.webp",
        date: new Date(2022, 11, 3),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@merakisbubble",
          ig_followers_count: "28.6k",
          photo: "/images/reviews/merakisbubble_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Salma",
        text: "Shemsi makes you forget the pads forever",
        imageUrl: "/images/reviews/salmasalah_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@salmasalaheddine",
          ig_followers_count: "2.2M",
          photo: "/images/reviews/salmasalah_profile.webp",
          videoId: "vpPNGb1F8Yo",
        },
      },
      {
        name: "valentina",
        type: ReviewerType.CUSTOMER,
        text: "من كتر ما عجبني, بقترحه على اصحاي",
        date: new Date(2022, 9, 14),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Shimaa",
        type: ReviewerType.CUSTOMER,
        text: "خدمة العملاء و المنتج ممتازين, و ده كان اسهل طلب اطلبه في حياتي",
        date: new Date(2022, 9, 13),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Laila",
        text: "Shemsi is so easy to wear and clean, it's a revolution for me! ",
        imageUrl: "/images/reviews/lailazaouiofficiel_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@lailazaouiofficiel",
          ig_followers_count: "451k",
          photo: "/images/reviews/lailazaouiofficiel_profile.webp",
          videoId: "sulnGc3hnD4",
        },
      },
      {
        name: "Rehab",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 13),
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "lina",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        date: new Date(2022, 9, 10),
        stars: 5,
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "Sara",
        type: ReviewerType.CUSTOMER,
        text: "Very good product and the website was very easy to use",
        date: new Date(2022, 9, 8),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Hagar",
        type: ReviewerType.CUSTOMER,
        text: "من احسن القرارات الي خدتها في حياتي",
        date: new Date(2022, 9, 7),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Hend",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        date: new Date(2022, 9, 6),
        stars: 5,
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Jihane",
        text: "Super confortable ce nouveau modèle",
        imageUrl: "/images/reviews/its_jihane_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@its_jihane_",
          ig_followers_count: "10.6k",
          photo: "/images/reviews/its_jihane_profile.webp",
          videoId: "gFKAoAE6xxA",
        },
      },
      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mirna",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و كل التفاصيل باينة على الموقع",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rawan",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Camelia",
        text: "This is insanely comfortable , zero leakage and made me even forget I was on my period - perfect product",
        imageUrl: "/images/reviews/camelia_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@camelia.asln",
          ig_followers_count: "19.8k",
          photo: "/images/reviews/camelia_profile.webp",
          videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Hajar",
        type: ReviewerType.CUSTOMER,
        text: "جودة ممتازة و كل الخدمات ممتازة",
        stars: 5,
        date: new Date(2022, 9, 4),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان في افل من يومين",
        stars: 5,
        date: new Date(2022, 9, 3),
        country: {
          name: "Giza",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Miray",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        type: ReviewerType.INFLUENCER,
        name: "Yasmine",
        text: "Super confortable ce nouveau modèle",
        imageUrl: "/images/reviews/outwithyas_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@outwithyas",
          ig_followers_count: "28.9k",
          photo: "/images/reviews/outwithyas_profile.webp",
          videoId: "1rHnPv5FqmY",
        },
      },
      {
        name: "Zeinab",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو اوي, محتاجة بس مدة التوصيل تكون اوضح",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Jehan",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة جداً بشكل عام",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Giza",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Nassima",
        text: "alors premièrement kont khayfa bzaf, je l'ai testé chez moi pendant toute une journée et après je l'ai testé dehors pour faire mes courses et sincèrement j'adore, je n'utilise que le pack havana à chaque fois que j'ai mes règles, je vais recommander 1 de plus là modèle alexandria inchalah",
        imageUrl: "/images/reviews/withnassima_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@withnassima",
          ig_followers_count: "215k",
          photo: "/images/reviews/withnassima_profile.webp",
          videoId: "M-072pR0fFk",
        },
      },
      {
        name: "Sarah",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mayar",
        type: ReviewerType.CUSTOMER,
        text: "تجربة الطلب سهلة جداً و المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nourhan",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداً و بقترحه جداً للناس",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Alexandria",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Safaa",
        text: "les culottes sont juste maginifique !!! Zero fuite , zero odeur et super confortables :) Merci Shemsi",
        imageUrl: "/images/reviews/thisissafaa_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@thisissafaa",
          ig_followers_count: "624k",
          photo: "/images/reviews/thisissafaa_profile.webp",
          videoId: "aq2CJRAsfLI",
        },
      },

      {
        type: ReviewerType.CUSTOMER,
        name: "Douaa",
        text: "c'est magnifiuque c'est vraiment ce que je cherchais depuis longtemps je vous souhaite une bonne continuation",

        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,
      },
    ],
  },
  {
    internalProductName: "alexandria",
    reviews: [
      {
        type: ReviewerType.INFLUENCER,
        name: "Camelia",
        text: "This is insanely comfortable , zero leakage and made me even forget I was on my period - perfect product",
        imageUrl: "/images/reviews/camelia_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@camelia.asln",
          ig_followers_count: "19.8k",
          photo: "/images/reviews/camelia_profile.webp",
          videoId: "hHJaJ1n8E6w",
        },
      },

      {
        name: "Dalia",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداًً و كان سهل اوي اني اطلبه",
        stars: 5,
        date: new Date(2022, 11, 2),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Salma",
        type: ReviewerType.CUSTOMER,
        text: "المنج ممتاز بس مكنتش عارفه اغسله ازاي, لكن خدمة العملاء ساعدوني",
        stars: 5,
        date: new Date(2022, 10, 4),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.CUSTOMER,
        name: "Sandra",
        text: "I got it for my daughter and she said they're really good with her",
        date: new Date(2022, 10, 12),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nada",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداً  بس ياريت لو كان في الوان",
        stars: 5,
        date: new Date(2022, 10, 8),
        country: {
          name: "Qalioubiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Marwa",
        text: "agréablement surpis de la douceur du coton",
        imageUrl: "/images/reviews/marwarioui_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@marwarioui",
          ig_followers_count: "2.1M",
          photo: "/images/reviews/marwarioui_profile.webp",
          videoId: "hg_s1eYSYrU",
        },
      },
      {
        name: "Dalia",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 10, 7),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "شيما",
        type: ReviewerType.CUSTOMER,
        text: "طلبته كذا مرة و كويس جداً",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Mansoura",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Aya",
        type: ReviewerType.CUSTOMER,
        text: "المنج ممتاز بس مكنتش عارفه اغسله ازاي, لكن خدمة العملاء ساعدوني",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Hadeer",
        text: "I love shemsi, I was so happy to try it and it really feels super hygienic. You really have to try it, to understand it!",
        date: new Date(2022, 11, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,
        imageUrl: "/images/reviews/thehadeerhameed_review.webp",
        influencer: {
          ig_handle: "@thehadeerhameed",
          ig_followers_count: "263k",
          photo: "/images/reviews/thehadeerhameed_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },

      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "طلبته مرتين و كل مرة كان مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nermine",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "esraa",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Sohag",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Zineb",
        text: "its crazy that this underwear works so well, it's a game changer ",
        imageUrl: "/images/reviews/zineb_aghrib_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@zineb_aghrib",
          ig_followers_count: "368k",
          photo: "/images/reviews/zineb_aghrib_profile.webp",
          videoId: "HmIuRWoxvaw",
        },
      },
      {
        name: "Amira",
        type: ReviewerType.CUSTOMER,
        text: "طلبته لبنتي و عجبها جداً",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "aya",
        type: ReviewerType.CUSTOMER,
        text: "المنتج روعة",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Sarah",
        text: "I really think it's amazing that this is Made in Egypt, it's amazing product for woman and it makes me feel so feminine ",
        imageUrl: "/images/reviews/glammedbysarah_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@glammedbysarah_",
          ig_followers_count: "223k",
          photo: "/images/reviews/glammedbysarah_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداً",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Amr",
        type: ReviewerType.CUSTOMER,
        text: "مراتي شكرت فيه",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Fayyoum",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "رحاب",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداً و بقترحه جداً للناس",
        date: new Date(2022, 9, 26),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Zeezee",
        text: "This is so much better then normal period products. Its good for the environment and has 0 chemical inside and is made of organic fabrics from Egypt. It's better for the planet and for you!",
        imageUrl: "/images/reviews/zeezeesaifelnasr_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@zeezeesaifelnasr",
          ig_followers_count: "111k",
          photo: "/images/reviews/zeezeesaifelnasr_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Salma",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة منه جداً",
        stars: 5,
        date: new Date(2022, 9, 25),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Sahar",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Mansora",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "نورا",
        type: ReviewerType.CUSTOMER,
        text: "طلبت 3 قطع و 2 منهم كانو حلوين جداً, و التالت حاسة انه مختلف لكن متأكدة ان لو طلع في حاجة مش مضبوطة خدمة العملاء هيساعدوني",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Port Said",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Jumana",
        text: "Period Underwear is super nice because you can sleep in peace with it. No more stress during your Period. I recommend it!! ",
        imageUrl: "/images/reviews/jumana_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@jumanaabdallah",
          ig_followers_count: "70.5k",
          photo: "/images/reviews/jumana_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Perry",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 21),
        country: {
          name: "Qalioubiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "shahed",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة جداً من المنتج و من خدمة العملاء",
        stars: 5,
        date: new Date(2022, 9, 20),
        country: {
          name: "Suez",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Malak",
        text: "Period Underwear is comfy its super nice to wear and it works! I've worn it for 10 Hours without any leaks 🤗",
        imageUrl: "/images/reviews/malakiees_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@malakiies",
          ig_followers_count: "163k",
          photo: "/images/reviews/malakiees_profile.webp",
          videoId: "eHdk-thVPds",
        },
      },
      {
        name: "Abdullah",
        type: ReviewerType.CUSTOMER,
        text: "المنتج كويس",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Enas",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Ismailia",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Youmna",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداًً و بستخدمه و انا في الGym",
        date: new Date(2022, 9, 19),
        stars: 5,
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 15),
        country: {
          name: "Kafr El Sheikh",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Salma",
        text: "I love shemsi as it allows me to feel free at the gym, no stress, no leak and ultra comfy for sports",
        imageUrl: "/images/reviews/merakisbubble_review.webp",
        date: new Date(2022, 11, 3),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@merakisbubble",
          ig_followers_count: "28.6k",
          photo: "/images/reviews/merakisbubble_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Salma",
        text: "Shemsi makes you forget the pads forever",
        imageUrl: "/images/reviews/salmasalah_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@salmasalaheddine",
          ig_followers_count: "2.2M",
          photo: "/images/reviews/salmasalah_profile.webp",
          videoId: "vpPNGb1F8Yo",
        },
      },
      {
        name: "valentina",
        type: ReviewerType.CUSTOMER,
        text: "من كتر ما عجبني, بقترحه على اصحاي",
        date: new Date(2022, 9, 14),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Shimaa",
        type: ReviewerType.CUSTOMER,
        text: "خدمة العملاء و المنتج ممتازين, و ده كان اسهل طلب اطلبه في حياتي",
        date: new Date(2022, 9, 13),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Laila",
        text: "Shemsi is so easy to wear and clean, it's a revolution for me! ",
        imageUrl: "/images/reviews/lailazaouiofficiel_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@lailazaouiofficiel",
          ig_followers_count: "451k",
          photo: "/images/reviews/lailazaouiofficiel_profile.webp",
          videoId: "sulnGc3hnD4",
        },
      },
      {
        name: "Rehab",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 13),
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "lina",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        date: new Date(2022, 9, 10),
        stars: 5,
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "Sara",
        type: ReviewerType.CUSTOMER,
        text: "Very good product and the website was very easy to use",
        date: new Date(2022, 9, 8),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Hagar",
        type: ReviewerType.CUSTOMER,
        text: "من احسن القرارات الي خدتها في حياتي",
        date: new Date(2022, 9, 7),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Hend",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        date: new Date(2022, 9, 6),
        stars: 5,
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Jihane",
        text: "Super confortable ce nouveau modèle",
        imageUrl: "/images/reviews/its_jihane_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@its_jihane_",
          ig_followers_count: "10.6k",
          photo: "/images/reviews/its_jihane_profile.webp",
          videoId: "gFKAoAE6xxA",
        },
      },
      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mirna",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و كل التفاصيل باينة على الموقع",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rawan",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Yasmine",
        text: "Words fail to express my gratitude to SHEMSI , I can't describe what I'm feeling really. This is the first time to sleep well throughout my periods. I want to say I was too hesitated and afraid to try shemsi without pads and when I bought them I said to myself if not real I would use them with pads. But I am excited , no leaks, no stain , no odor , only comfort and freedom like you are wearing not",
        imageUrl: "/images/reviews/harikaol_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@harikaol",
          ig_followers_count: "159k",
          photo: "/images/reviews/harikaol_profile.webp",
          videoId: "k1OW7T5vIi8",
        },
      },
      {
        name: "Hajar",
        type: ReviewerType.CUSTOMER,
        text: "جودة ممتازة و كل الخدمات ممتازة",
        stars: 5,
        date: new Date(2022, 9, 4),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان في افل من يومين",
        stars: 5,
        date: new Date(2022, 9, 3),
        country: {
          name: "Giza",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Miray",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        type: ReviewerType.INFLUENCER,
        name: "Yasmine",
        text: "Super confortable ce nouveau modèle",
        imageUrl: "/images/reviews/outwithyas_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@outwithyas",
          ig_followers_count: "28.9k",
          photo: "/images/reviews/outwithyas_profile.webp",
          videoId: "1rHnPv5FqmY",
        },
      },
      {
        name: "Zeinab",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو اوي, محتاجة بس مدة التوصيل تكون اوضح",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Jehan",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة جداً بشكل عام",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Giza",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Nassima",
        text: "alors premièrement kont khayfa bzaf, je l'ai testé chez moi pendant toute une journée et après je l'ai testé dehors pour faire mes courses et sincèrement j'adore, je n'utilise que le pack havana à chaque fois que j'ai mes règles, je vais recommander 1 de plus là modèle alexandria inchalah",
        imageUrl: "/images/reviews/withnassima_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@withnassima",
          ig_followers_count: "215k",
          photo: "/images/reviews/withnassima_profile.webp",
          videoId: "M-072pR0fFk",
        },
      },
      {
        name: "Sarah",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mayar",
        type: ReviewerType.CUSTOMER,
        text: "تجربة الطلب سهلة جداً و المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nourhan",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداً و بقترحه جداً للناس",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Alexandria",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Safaa",
        text: "les culottes sont juste maginifique !!! Zero fuite , zero odeur et super confortables :) Merci Shemsi",
        imageUrl: "/images/reviews/thisissafaa_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@thisissafaa",
          ig_followers_count: "624k",
          photo: "/images/reviews/thisissafaa_profile.webp",
          videoId: "aq2CJRAsfLI",
        },
      },

      {
        type: ReviewerType.CUSTOMER,
        name: "Douaa",
        text: "c'est magnifiuque c'est vraiment ce que je cherchais depuis longtemps je vous souhaite une bonne continuation",

        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,
      },
    ],
  },
  {
    internalProductName: "havana",
    reviews: [
      {
        type: ReviewerType.INFLUENCER,
        name: "Nassima",
        text: "alors premièrement kont khayfa bzaf, je l'ai testé chez moi pendant toute une journée et après je l'ai testé dehors pour faire mes courses et sincèrement j'adore, je n'utilise que le pack havana à chaque fois que j'ai mes règles, je vais recommander 1 de plus là modèle alexandria inchalah",
        imageUrl: "/images/reviews/withnassima_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },

        stars: 5,

        influencer: {
          ig_handle: "@withnassima",
          ig_followers_count: "215k",
          photo: "/images/reviews/withnassima_profile.webp",
          videoId: "M-072pR0fFk",
        },
      },
      {
        name: "Dalia",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداًً و كان سهل اوي اني اطلبه",
        stars: 5,
        date: new Date(2022, 11, 2),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Salma",
        type: ReviewerType.CUSTOMER,
        text: "المنج ممتاز بس مكنتش عارفه اغسله ازاي, لكن خدمة العملاء ساعدوني",
        stars: 5,
        date: new Date(2022, 10, 4),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.CUSTOMER,
        name: "Sandra",
        text: "I got it for my daughter and she said they're really good with her",
        date: new Date(2022, 10, 12),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nada",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداً  بس ياريت لو كان في الوان",
        stars: 5,
        date: new Date(2022, 10, 8),
        country: {
          name: "Qalioubiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Marwa",
        text: "agréablement surpis de la douceur du coton",
        imageUrl: "/images/reviews/marwarioui_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@marwarioui",
          ig_followers_count: "2.1M",
          photo: "/images/reviews/marwarioui_profile.webp",
          videoId: "hg_s1eYSYrU",
        },
      },
      {
        name: "Dalia",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 10, 7),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "شيما",
        type: ReviewerType.CUSTOMER,
        text: "طلبته كذا مرة و كويس جداً",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Mansoura",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Aya",
        type: ReviewerType.CUSTOMER,
        text: "المنج ممتاز بس مكنتش عارفه اغسله ازاي, لكن خدمة العملاء ساعدوني",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Hadeer",
        text: "I love shemsi, I was so happy to try it and it really feels super hygienic. You really have to try it, to understand it!",
        date: new Date(2022, 11, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,
        imageUrl: "/images/reviews/thehadeerhameed_review.webp",
        influencer: {
          ig_handle: "@thehadeerhameed",
          ig_followers_count: "263k",
          photo: "/images/reviews/thehadeerhameed_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },

      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "طلبته مرتين و كل مرة كان مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nermine",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "esraa",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Sohag",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Zineb",
        text: "its crazy that this underwear works so well, it's a game changer ",
        imageUrl: "/images/reviews/zineb_aghrib_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@zineb_aghrib",
          ig_followers_count: "368k",
          photo: "/images/reviews/zineb_aghrib_profile.webp",
          videoId: "HmIuRWoxvaw",
        },
      },
      {
        name: "Amira",
        type: ReviewerType.CUSTOMER,
        text: "طلبته لبنتي و عجبها جداً",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "aya",
        type: ReviewerType.CUSTOMER,
        text: "المنتج روعة",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Sarah",
        text: "I really think it's amazing that this is Made in Egypt, it's amazing product for woman and it makes me feel so feminine ",
        imageUrl: "/images/reviews/glammedbysarah_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@glammedbysarah_",
          ig_followers_count: "223k",
          photo: "/images/reviews/glammedbysarah_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداً",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Amr",
        type: ReviewerType.CUSTOMER,
        text: "مراتي شكرت فيه",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Fayyoum",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "رحاب",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداً و بقترحه جداً للناس",
        date: new Date(2022, 9, 26),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Zeezee",
        text: "This is so much better then normal period products. Its good for the environment and has 0 chemical inside and is made of organic fabrics from Egypt. It's better for the planet and for you!",
        imageUrl: "/images/reviews/zeezeesaifelnasr_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@zeezeesaifelnasr",
          ig_followers_count: "111k",
          photo: "/images/reviews/zeezeesaifelnasr_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Salma",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة منه جداً",
        stars: 5,
        date: new Date(2022, 9, 25),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Sahar",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Mansora",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "نورا",
        type: ReviewerType.CUSTOMER,
        text: "طلبت 3 قطع و 2 منهم كانو حلوين جداً, و التالت حاسة انه مختلف لكن متأكدة ان لو طلع في حاجة مش مضبوطة خدمة العملاء هيساعدوني",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Port Said",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Jumana",
        text: "Period Underwear is super nice because you can sleep in peace with it. No more stress during your Period. I recommend it!! ",
        imageUrl: "/images/reviews/jumana_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@jumanaabdallah",
          ig_followers_count: "70.5k",
          photo: "/images/reviews/jumana_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Perry",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 21),
        country: {
          name: "Qalioubiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "shahed",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة جداً من المنتج و من خدمة العملاء",
        stars: 5,
        date: new Date(2022, 9, 20),
        country: {
          name: "Suez",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Malak",
        text: "Period Underwear is comfy its super nice to wear and it works! I've worn it for 10 Hours without any leaks 🤗",
        imageUrl: "/images/reviews/malakiees_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@malakiies",
          ig_followers_count: "163k",
          photo: "/images/reviews/malakiees_profile.webp",
          videoId: "eHdk-thVPds",
        },
      },
      {
        name: "Abdullah",
        type: ReviewerType.CUSTOMER,
        text: "المنتج كويس",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Enas",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Ismailia",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Youmna",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداًً و بستخدمه و انا في الGym",
        date: new Date(2022, 9, 19),
        stars: 5,
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 15),
        country: {
          name: "Kafr El Sheikh",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Salma",
        text: "I love shemsi as it allows me to feel free at the gym, no stress, no leak and ultra comfy for sports",
        imageUrl: "/images/reviews/merakisbubble_review.webp",
        date: new Date(2022, 11, 3),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@merakisbubble",
          ig_followers_count: "28.6k",
          photo: "/images/reviews/merakisbubble_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Salma",
        text: "Shemsi makes you forget the pads forever",
        imageUrl: "/images/reviews/salmasalah_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@salmasalaheddine",
          ig_followers_count: "2.2M",
          photo: "/images/reviews/salmasalah_profile.webp",
          videoId: "vpPNGb1F8Yo",
        },
      },
      {
        name: "valentina",
        type: ReviewerType.CUSTOMER,
        text: "من كتر ما عجبني, بقترحه على اصحاي",
        date: new Date(2022, 9, 14),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Shimaa",
        type: ReviewerType.CUSTOMER,
        text: "خدمة العملاء و المنتج ممتازين, و ده كان اسهل طلب اطلبه في حياتي",
        date: new Date(2022, 9, 13),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Laila",
        text: "Shemsi is so easy to wear and clean, it's a revolution for me! ",
        imageUrl: "/images/reviews/lailazaouiofficiel_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@lailazaouiofficiel",
          ig_followers_count: "451k",
          photo: "/images/reviews/lailazaouiofficiel_profile.webp",
          videoId: "sulnGc3hnD4",
        },
      },
      {
        name: "Rehab",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 13),
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "lina",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        date: new Date(2022, 9, 10),
        stars: 5,
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "Sara",
        type: ReviewerType.CUSTOMER,
        text: "Very good product and the website was very easy to use",
        date: new Date(2022, 9, 8),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Hagar",
        type: ReviewerType.CUSTOMER,
        text: "من احسن القرارات الي خدتها في حياتي",
        date: new Date(2022, 9, 7),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Hend",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        date: new Date(2022, 9, 6),
        stars: 5,
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Jihane",
        text: "Super confortable ce nouveau modèle",
        imageUrl: "/images/reviews/its_jihane_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@its_jihane_",
          ig_followers_count: "10.6k",
          photo: "/images/reviews/its_jihane_profile.webp",
          videoId: "gFKAoAE6xxA",
        },
      },
      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mirna",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و كل التفاصيل باينة على الموقع",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rawan",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Camelia",
        text: "This is insanely comfortable , zero leakage and made me even forget I was on my period - perfect product",
        imageUrl: "/images/reviews/camelia_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@camelia.asln",
          ig_followers_count: "19.8k",
          photo: "/images/reviews/camelia_profile.webp",
          videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Hajar",
        type: ReviewerType.CUSTOMER,
        text: "جودة ممتازة و كل الخدمات ممتازة",
        stars: 5,
        date: new Date(2022, 9, 4),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان في افل من يومين",
        stars: 5,
        date: new Date(2022, 9, 3),
        country: {
          name: "Giza",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Miray",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        type: ReviewerType.INFLUENCER,
        name: "Yasmine",
        text: "Super confortable ce nouveau modèle",
        imageUrl: "/images/reviews/outwithyas_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@outwithyas",
          ig_followers_count: "28.9k",
          photo: "/images/reviews/outwithyas_profile.webp",
          videoId: "1rHnPv5FqmY",
        },
      },
      {
        name: "Zeinab",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو اوي, محتاجة بس مدة التوصيل تكون اوضح",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Jehan",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة جداً بشكل عام",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Giza",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        type: ReviewerType.INFLUENCER,
        name: "Yasmine",
        text: "Words fail to express my gratitude to SHEMSI , I can't describe what I'm feeling really. This is the first time to sleep well throughout my periods. I want to say I was too hesitated and afraid to try shemsi without pads and when I bought them I said to myself if not real I would use them with pads. But I am excited , no leaks, no stain , no odor , only comfort and freedom like you are wearing not",
        imageUrl: "/images/reviews/harikaol_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@harikaol",
          ig_followers_count: "159k",
          photo: "/images/reviews/harikaol_profile.webp",
          videoId: "k1OW7T5vIi8",
        },
      },
      {
        name: "Sarah",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mayar",
        type: ReviewerType.CUSTOMER,
        text: "تجربة الطلب سهلة جداً و المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nourhan",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداً و بقترحه جداً للناس",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Alexandria",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Safaa",
        text: "les culottes sont juste maginifique !!! Zero fuite , zero odeur et super confortables :) Merci Shemsi",
        imageUrl: "/images/reviews/thisissafaa_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@thisissafaa",
          ig_followers_count: "624k",
          photo: "/images/reviews/thisissafaa_profile.webp",
          videoId: "aq2CJRAsfLI",
        },
      },

      {
        type: ReviewerType.CUSTOMER,
        name: "Douaa",
        text: "c'est magnifiuque c'est vraiment ce que je cherchais depuis longtemps je vous souhaite une bonne continuation",

        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,
      },
    ],
  },
  {
    internalProductName: "bahia",
    reviews: [
      {
        type: ReviewerType.INFLUENCER,
        name: "Camelia",
        text: "This is insanely comfortable , zero leakage and made me even forget I was on my period - perfect product",
        imageUrl: "/images/reviews/camelia_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@camelia.asln",
          ig_followers_count: "19.8k",
          photo: "/images/reviews/camelia_profile.webp",
          videoId: "hHJaJ1n8E6w",
        },
      },

      {
        name: "Dalia",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداًً و كان سهل اوي اني اطلبه",
        stars: 5,
        date: new Date(2022, 11, 2),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Salma",
        type: ReviewerType.CUSTOMER,
        text: "المنج ممتاز بس مكنتش عارفه اغسله ازاي, لكن خدمة العملاء ساعدوني",
        stars: 5,
        date: new Date(2022, 10, 4),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.CUSTOMER,
        name: "Sandra",
        text: "I got it for my daughter and she said they're really good with her",
        date: new Date(2022, 10, 12),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nada",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداً  بس ياريت لو كان في الوان",
        stars: 5,
        date: new Date(2022, 10, 8),
        country: {
          name: "Qalioubiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Marwa",
        text: "agréablement surpis de la douceur du coton",
        imageUrl: "/images/reviews/marwarioui_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@marwarioui",
          ig_followers_count: "2.1M",
          photo: "/images/reviews/marwarioui_profile.webp",
          videoId: "hg_s1eYSYrU",
        },
      },
      {
        name: "Dalia",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 10, 7),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "شيما",
        type: ReviewerType.CUSTOMER,
        text: "طلبته كذا مرة و كويس جداً",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Mansoura",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Aya",
        type: ReviewerType.CUSTOMER,
        text: "المنج ممتاز بس مكنتش عارفه اغسله ازاي, لكن خدمة العملاء ساعدوني",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Hadeer",
        text: "I love shemsi, I was so happy to try it and it really feels super hygienic. You really have to try it, to understand it!",
        date: new Date(2022, 11, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,
        imageUrl: "/images/reviews/thehadeerhameed_review.webp",
        influencer: {
          ig_handle: "@thehadeerhameed",
          ig_followers_count: "263k",
          photo: "/images/reviews/thehadeerhameed_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },

      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "طلبته مرتين و كل مرة كان مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nermine",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "esraa",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Sohag",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Zineb",
        text: "its crazy that this underwear works so well, it's a game changer ",
        imageUrl: "/images/reviews/zineb_aghrib_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@zineb_aghrib",
          ig_followers_count: "368k",
          photo: "/images/reviews/zineb_aghrib_profile.webp",
          videoId: "HmIuRWoxvaw",
        },
      },
      {
        name: "Amira",
        type: ReviewerType.CUSTOMER,
        text: "طلبته لبنتي و عجبها جداً",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "aya",
        type: ReviewerType.CUSTOMER,
        text: "المنتج روعة",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Sarah",
        text: "I really think it's amazing that this is Made in Egypt, it's amazing product for woman and it makes me feel so feminine ",
        imageUrl: "/images/reviews/glammedbysarah_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@glammedbysarah_",
          ig_followers_count: "223k",
          photo: "/images/reviews/glammedbysarah_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداً",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Amr",
        type: ReviewerType.CUSTOMER,
        text: "مراتي شكرت فيه",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Fayyoum",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Salma",
        text: "Shemsi makes you forget the pads forever",
        imageUrl: "/images/reviews/salmasalah_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@salmasalaheddine",
          ig_followers_count: "2.2M",
          photo: "/images/reviews/salmasalah_profile.webp",
          videoId: "vpPNGb1F8Yo",
        },
      },
      {
        name: "رحاب",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداً و بقترحه جداً للناس",
        date: new Date(2022, 9, 26),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "Salma",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة منه جداً",
        stars: 5,
        date: new Date(2022, 9, 25),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Sahar",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Mansora",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "نورا",
        type: ReviewerType.CUSTOMER,
        text: "طلبت 3 قطع و 2 منهم كانو حلوين جداً, و التالت حاسة انه مختلف لكن متأكدة ان لو طلع في حاجة مش مضبوطة خدمة العملاء هيساعدوني",
        stars: 5,
        date: new Date(2022, 9, 23),
        country: {
          name: "Port Said",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Jumana",
        text: "Period Underwear is super nice because you can sleep in peace with it. No more stress during your Period. I recommend it!! ",
        imageUrl: "/images/reviews/jumana_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@jumanaabdallah",
          ig_followers_count: "70.5k",
          photo: "/images/reviews/jumana_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Perry",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 21),
        country: {
          name: "Qalioubiya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "shahed",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة جداً من المنتج و من خدمة العملاء",
        stars: 5,
        date: new Date(2022, 9, 20),
        country: {
          name: "Suez",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Malak",
        text: "Period Underwear is comfy its super nice to wear and it works! I've worn it for 10 Hours without any leaks 🤗",
        imageUrl: "/images/reviews/malakiees_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@malakiies",
          ig_followers_count: "163k",
          photo: "/images/reviews/malakiees_profile.webp",
          videoId: "eHdk-thVPds",
        },
      },
      {
        name: "Abdullah",
        type: ReviewerType.CUSTOMER,
        text: "المنتج كويس",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Enas",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 19),
        country: {
          name: "Ismailia",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Youmna",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداًً و بستخدمه و انا في الGym",
        date: new Date(2022, 9, 19),
        stars: 5,
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 15),
        country: {
          name: "Kafr El Sheikh",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Salma",
        text: "I love shemsi as it allows me to feel free at the gym, no stress, no leak and ultra comfy for sports",
        imageUrl: "/images/reviews/merakisbubble_review.webp",
        date: new Date(2022, 11, 3),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@merakisbubble",
          ig_followers_count: "28.6k",
          photo: "/images/reviews/merakisbubble_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },

      {
        name: "valentina",
        type: ReviewerType.CUSTOMER,
        text: "من كتر ما عجبني, بقترحه على اصحاي",
        date: new Date(2022, 9, 14),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Shimaa",
        type: ReviewerType.CUSTOMER,
        text: "خدمة العملاء و المنتج ممتازين, و ده كان اسهل طلب اطلبه في حياتي",
        date: new Date(2022, 9, 13),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Laila",
        text: "Shemsi is so easy to wear and clean, it's a revolution for me! ",
        imageUrl: "/images/reviews/lailazaouiofficiel_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@lailazaouiofficiel",
          ig_followers_count: "451k",
          photo: "/images/reviews/lailazaouiofficiel_profile.webp",
          videoId: "sulnGc3hnD4",
        },
      },
      {
        name: "Rehab",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 13),
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "lina",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        date: new Date(2022, 9, 10),
        stars: 5,
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "Sara",
        type: ReviewerType.CUSTOMER,
        text: "Very good product and the website was very easy to use",
        date: new Date(2022, 9, 8),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Hagar",
        type: ReviewerType.CUSTOMER,
        text: "من احسن القرارات الي خدتها في حياتي",
        date: new Date(2022, 9, 7),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Hend",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        date: new Date(2022, 9, 6),
        stars: 5,
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Jihane",
        text: "Super confortable ce nouveau modèle",
        imageUrl: "/images/reviews/its_jihane_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@its_jihane_",
          ig_followers_count: "10.6k",
          photo: "/images/reviews/its_jihane_profile.webp",
          videoId: "gFKAoAE6xxA",
        },
      },
      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mirna",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و كل التفاصيل باينة على الموقع",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rawan",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Zeezee",
        text: "This is so much better then normal period products. Its good for the environment and has 0 chemical inside and is made of organic fabrics from Egypt. It's better for the planet and for you!",
        imageUrl: "/images/reviews/zeezeesaifelnasr_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@zeezeesaifelnasr",
          ig_followers_count: "111k",
          photo: "/images/reviews/zeezeesaifelnasr_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },
      {
        name: "Hajar",
        type: ReviewerType.CUSTOMER,
        text: "جودة ممتازة و كل الخدمات ممتازة",
        stars: 5,
        date: new Date(2022, 9, 4),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان في افل من يومين",
        stars: 5,
        date: new Date(2022, 9, 3),
        country: {
          name: "Giza",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Miray",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Yasmine",
        text: "Words fail to express my gratitude to SHEMSI , I can't describe what I'm feeling really. This is the first time to sleep well throughout my periods. I want to say I was too hesitated and afraid to try shemsi without pads and when I bought them I said to myself if not real I would use them with pads. But I am excited , no leaks, no stain , no odor , only comfort and freedom like you are wearing not",
        imageUrl: "/images/reviews/harikaol_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@harikaol",
          ig_followers_count: "159k",
          photo: "/images/reviews/harikaol_profile.webp",
          videoId: "k1OW7T5vIi8",
        },
      },
      {
        name: "Zeinab",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو اوي, محتاجة بس مدة التوصيل تكون اوضح",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Jehan",
        type: ReviewerType.CUSTOMER,
        text: "مبسوطة جداً بشكل عام",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Giza",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Nassima",
        text: "alors premièrement kont khayfa bzaf, je l'ai testé chez moi pendant toute une journée et après je l'ai testé dehors pour faire mes courses et sincèrement j'adore, je n'utilise que le pack havana à chaque fois que j'ai mes règles, je vais recommander 1 de plus là modèle alexandria inchalah",
        imageUrl: "/images/reviews/withnassima_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@withnassima",
          ig_followers_count: "215k",
          photo: "/images/reviews/withnassima_profile.webp",
          videoId: "M-072pR0fFk",
        },
      },
      {
        name: "Sarah",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mayar",
        type: ReviewerType.CUSTOMER,
        text: "تجربة الطلب سهلة جداً و المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nourhan",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداً و بقترحه جداً للناس",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Alexandria",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Safaa",
        text: "les culottes sont juste maginifique !!! Zero fuite , zero odeur et super confortables :) Merci Shemsi",
        imageUrl: "/images/reviews/thisissafaa_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@thisissafaa",
          ig_followers_count: "624k",
          photo: "/images/reviews/thisissafaa_profile.webp",
          videoId: "aq2CJRAsfLI",
        },
      },

      {
        type: ReviewerType.CUSTOMER,
        name: "Douaa",
        text: "c'est magnifiuque c'est vraiment ce que je cherchais depuis longtemps je vous souhaite une bonne continuation",

        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,
      },
    ],
  },
  {
    internalProductName: "copacabana",
    reviews: [
      {
        name: "Dalia",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 10, 7),
        country: {
          name: "Sharqiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "شيما",
        type: ReviewerType.CUSTOMER,
        text: "طلبته كذا مرة و كويس جداً",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Mansoura",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Aya",
        type: ReviewerType.CUSTOMER,
        text: "المنج ممتاز بس مكنتش عارفه اغسله ازاي, لكن خدمة العملاء ساعدوني",
        stars: 5,
        date: new Date(2022, 10, 6),
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Hadeer",
        text: "I love shemsi, I was so happy to try it and it really feels super hygienic. You really have to try it, to understand it!",
        date: new Date(2022, 11, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,
        imageUrl: "/images/reviews/thehadeerhameed_review.webp",
        influencer: {
          ig_handle: "@thehadeerhameed",
          ig_followers_count: "263k",
          photo: "/images/reviews/thehadeerhameed_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },

      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "طلبته مرتين و كل مرة كان مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج حلو جداً",
        stars: 5,
        date: new Date(2022, 9, 26),
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "valentina",
        type: ReviewerType.CUSTOMER,
        text: "من كتر ما عجبني, بقترحه على اصحاي",
        date: new Date(2022, 9, 14),
        stars: 5,
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Shimaa",
        type: ReviewerType.CUSTOMER,
        text: "خدمة العملاء و المنتج ممتازين, و ده كان اسهل طلب اطلبه في حياتي",
        date: new Date(2022, 9, 13),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Laila",
        text: "Shemsi is so easy to wear and clean, it's a revolution for me! ",
        imageUrl: "/images/reviews/lailazaouiofficiel_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@lailazaouiofficiel",
          ig_followers_count: "451k",
          photo: "/images/reviews/lailazaouiofficiel_profile.webp",
          videoId: "sulnGc3hnD4",
        },
      },
      {
        name: "Rehab",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 13),
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "lina",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        date: new Date(2022, 9, 10),
        stars: 5,
        country: {
          name: "Gharbiya",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mirna",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و كل التفاصيل باينة على الموقع",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rawan",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Zeezee",
        text: "This is so much better then normal period products. Its good for the environment and has 0 chemical inside and is made of organic fabrics from Egypt. It's better for the planet and for you!",
        imageUrl: "/images/reviews/zeezeesaifelnasr_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@zeezeesaifelnasr",
          ig_followers_count: "111k",
          photo: "/images/reviews/zeezeesaifelnasr_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },

      {
        type: ReviewerType.INFLUENCER,
        name: "Nassima",
        text: "alors premièrement kont khayfa bzaf, je l'ai testé chez moi pendant toute une journée et après je l'ai testé dehors pour faire mes courses et sincèrement j'adore, je n'utilise que le pack havana à chaque fois que j'ai mes règles, je vais recommander 1 de plus là modèle alexandria inchalah",
        imageUrl: "/images/reviews/withnassima_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@withnassima",
          ig_followers_count: "215k",
          photo: "/images/reviews/withnassima_profile.webp",
          videoId: "M-072pR0fFk",
        },
      },
      {
        name: "Sarah",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع",
        stars: 5,
        date: new Date(2022, 9, 2),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mayar",
        type: ReviewerType.CUSTOMER,
        text: "تجربة الطلب سهلة جداً و المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
    ],
  },
  {
    internalProductName: "waikiki",
    reviews: [
      {
        name: "Mona",
        type: ReviewerType.CUSTOMER,
        text: "طلبته مرتين و كل مرة كان مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Nermine",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز",
        stars: 5,
        date: new Date(2022, 9, 29),
        country: {
          name: "Red Sea",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "esraa",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداً",
        stars: 5,
        date: new Date(2022, 9, 28),
        country: {
          name: "Sohag",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        type: ReviewerType.INFLUENCER,
        name: "Jumana",
        text: "Period Underwear is super nice because you can sleep in peace with it. No more stress during your Period. I recommend it!! ",
        imageUrl: "/images/reviews/jumana_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@jumanaabdallah",
          ig_followers_count: "70.5k",
          photo: "/images/reviews/jumana_profile.webp",
          // videoId: "hHJaJ1n8E6w",
        },
      },

      {
        name: "Youmna",
        type: ReviewerType.CUSTOMER,
        text: "حلو جداًً و بستخدمه و انا في الGym",
        date: new Date(2022, 9, 19),
        stars: 5,
        country: {
          name: "Damietta",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rasha",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 15),
        country: {
          name: "Kafr El Sheikh",
          icon: "/images/flags/egypt.svg",
        },
      },

      {
        name: "Hagar",
        type: ReviewerType.CUSTOMER,
        text: "من احسن القرارات الي خدتها في حياتي",
        date: new Date(2022, 9, 7),
        stars: 5,
        country: {
          name: "Daqahliya",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        type: ReviewerType.INFLUENCER,
        name: "Jihane",
        text: "Super confortable ce nouveau modèle",
        imageUrl: "/images/reviews/its_jihane_review.webp",
        date: new Date(2022, 5, 1),
        country: {
          name: "Casablanca",
          icon: "/images/flags/morocco.svg",
        },
        stars: 5,

        influencer: {
          ig_handle: "@its_jihane_",
          ig_followers_count: "10.6k",
          photo: "/images/reviews/its_jihane_profile.webp",
          videoId: "gFKAoAE6xxA",
        },
      },
      {
        name: "Rana",
        type: ReviewerType.CUSTOMER,
        text: "المنتج ممتاز و سرعة الرد على الصفحة ممتاز و التوصيل كان سريع جداً",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Mirna",
        type: ReviewerType.CUSTOMER,
        text: "جودة المنتج عالية جداً و كل التفاصيل باينة على الموقع",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
      {
        name: "Rawan",
        type: ReviewerType.CUSTOMER,
        text: "المنتج مريح جداًً و ال website سهل استخدامه",
        stars: 5,
        date: new Date(2022, 9, 6),
        country: {
          name: "Cairo",
          icon: "/images/flags/egypt.svg",
        },
      },
    ],
  },
];

export default reviewsPerProduct;
